__turbopack_context__.v({
  "button": "MarkdownFormattingToolbar-module__pSw-bG__button",
  "divider": "MarkdownFormattingToolbar-module__pSw-bG__divider",
  "glyphBold": "MarkdownFormattingToolbar-module__pSw-bG__glyphBold",
  "glyphHeading": "MarkdownFormattingToolbar-module__pSw-bG__glyphHeading",
  "glyphItalic": "MarkdownFormattingToolbar-module__pSw-bG__glyphItalic",
  "markdownHintButton": "MarkdownFormattingToolbar-module__pSw-bG__markdownHintButton",
  "markdownHintIcon": "MarkdownFormattingToolbar-module__pSw-bG__markdownHintIcon",
  "markdownHintWrapper": "MarkdownFormattingToolbar-module__pSw-bG__markdownHintWrapper",
  "root": "MarkdownFormattingToolbar-module__pSw-bG__root",
  "rootDisabled": "MarkdownFormattingToolbar-module__pSw-bG__rootDisabled",
});
